<div
    class="betslip-panicslider"
    [msSwipeContainer]="swipeEnabled"
    [swipeEndThreshold]="swipeEndThreshold"
    [swipeStartThreshold]="swipeStartThreshold">
    <div class="betslip-panicslider-label">
        <span>{{ sitecore.panicButtonMessages.PanicButtonMobileLabel }}</span>
    </div>
    <div
        #panicSlider
        class="betslip-panicslider-slider"
        [msSwipeActions]="swipeTemplate"
        (panstart)="onPanStart()"
        (panmove)="onPanMove($any($event))">
        <i class="theme-hand-icon"></i>
        <span>{{ sitecore.panicButtonMessages.PanicButtonSliderText }}</span>
        <div class="arrow-right">
            <i class="theme-arrow-icon"></i>
        </div>
    </div>
    <ng-template #swipeTemplate>
        <div class="swipped-in">
            <span>{{ sitecore.panicButtonMessages.PanicButtonSliderActivated }}</span>
        </div>
    </ng-template>
</div>
